import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { getLocationDetails } from '@avanta/shared/utils/appointments';
import { formatDateReadable, formatTime } from '@avanta/shared/utils/date';
import { Calendar, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { type Appointment, AppointmentType } from 'types/appointments';
import { Detail } from '../Detail';

interface SessionDetailsSectionProps {
  appointment: Appointment;
}

export const SessionDetailsSection = ({
  appointment,
}: SessionDetailsSectionProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const isRemoteAppointment = appointment.bookedContactMethod === AppointmentType.Video;
  const locationDetails = getLocationDetails(appointment, isRemoteAppointment);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-md font-medium text-denim-600">{t('AppointmentCard.details.heading')}</p>
      <div className="grid grid-cols-2 gap-4 max-am-lg:grid-cols-1">
        <Detail
          icon={Calendar}
          title={t('AppointmentCard.date.label')}
          value={formatDateReadable(appointment.dateTime, 'dd/MM/yyyy')}
        />
        <Detail
          icon={Clock}
          title={t('AppointmentCard.time.label')}
          value={formatTime(appointment.dateTime, 'HH:mm:ss')}
        />
        {locationDetails.map((detail, index) => (
          <Detail key={index} {...detail} />
        ))}
      </div>
    </div>
  );
};
